module.exports = __webpack_public_path__ + "5b0b766032feb7718838b5199ebc00bf.png";